import { useStatistic } from "@gymflow/api";
import { DATE_FORMAT, PARAMETER_DATE_ONLY_FORMAT } from "@gymflow/common";
import moment from "moment";
import { useContext } from "react";

import { ApiResolverContext } from "../../../../providers/ApiResolverProvider/ApiResolverContext";
import useGymflowModels from "../../../../store";
import ReportWidgetCard from "../../../ReportWidgetCard/ReportWidgetCard";
import { ReportContext } from "../../ReportContext";

export const ReportMembersActiveWidget = () => {
  const context = useContext(ReportContext);

  const { api } = useGymflowModels();
  const { clubId } = useContext(ApiResolverContext);
  const { data, isLoading } = useStatistic({
    api,
    clubId,
    trendPeriod: "MONTH",
    categories: ["membership"],
    membershipFields: ["total", "active", "overdue", "paused", "pending"],
    start:
      context.endDate &&
      moment(context.endDate, DATE_FORMAT).format(PARAMETER_DATE_ONLY_FORMAT),
    end:
      context.endDate &&
      moment(context.endDate, DATE_FORMAT).format(PARAMETER_DATE_ONLY_FORMAT),
    membershipIncluded: context?.membershipIncluded?.map(({ id }) => id),
    membershipExcluded: context?.membershipExcluded?.map(({ id }) => id),
  });

  return (
    <ReportWidgetCard
      title="Active Memberships"
      value={data?.membership?.active?.total?.toString() || "0"}
      isLoading={isLoading}
      explanation="Sum of all recurring and pre-paid membership with an Active status."
      variation={data?.membership?.active?.var}
    />
  );
};
